import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';

import StoreConfigButton from '@stubhub/react-store-config-button';

import FilterIcon from '../icons/filter';

// CSS
import './index.scss';

/**
 * Functional component shows event name
 * @param {String} eventName
 */
const EventFooterBottom = ({onClickFilter, filterCount = 0, isAdvisoryCurrencyEnabled, selectedCurrency}) => {
  const $indigo = '#3f1d75';

  return (
    <section className="EventFooterBottom">
      <div className="EventFooterBottom__filterContainer" onClick={onClickFilter}>
        <FilterIcon className="EventFooterBottom__filterIcon" color={$indigo} width="12px" height="12px" />
        <div className="EventFooterBottom__filterText">
          <FormattedMessage id="event.filter.bottom.filter" defaultMessage="Filters" />
        </div>
        {filterCount > 0 && <div className="EventFooterBottom__filterCount">{filterCount}</div>}
      </div>
      {isAdvisoryCurrencyEnabled ? (
        <StoreConfigButton enableLanguageSelector={false} enableCurrencySelector selectedCurrency={selectedCurrency} />
      ) : null}
    </section>
  );
};

EventFooterBottom.propTypes = {
  onClickFilter: PropTypes.func,
  filterCount: PropTypes.number,
  isAdvisoryCurrencyEnabled: PropTypes.bool,
  selectedCurrency: PropTypes.string,
};

export default EventFooterBottom;
